import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'
import { MyTimesheets } from '@/features/my-timesheets'

// Any authenticated member with a staff profile can view their own timesheets —
// not just workers (e.g. a Rostering Manager who also works shifts). The nav only
// surfaces this for staff-profile members, and the page resolves the caller's own
// staffId (showing "Staff profile not found" otherwise), so it never exposes
// another member's timesheet.
export const Route = createFileRoute('/_authenticated/_organization/my-timesheets/')({
  beforeLoad: async () => requireAuth(),
  component: MyTimesheets,
})

